export default __webpack_public_path__ + "static/media/placeholder_dummy2016-cafe01-de.f970c131.png";